import Vue from 'vue';
import VueRouter, {NavigationGuardNext, RawLocation, Route, RouteConfig} from 'vue-router';

import {articleRoutes} from '@/articles/router';
import {bookingRoutes} from '@/bookings/router';
import {feedbackRoutes} from '@/feedback/router';
import {menuRoutes} from '@/menu/router';

import {store} from './store';
import Cgu from './views/Cgu.vue';
import Home from './views/Home.vue';
import MentionsLegales from './views/MentionsLegales.vue';
import OnlineService from './views/OnlineService.vue';
import PageNotFound from './views/PageNotFound.vue';

Vue.use(VueRouter);

// Naviguer vers la route déjà active (ex: recliquer sur l'onglet en cours) rejette la
// promesse de VueRouter avec une NavigationDuplicated non catchée par les appelants.
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location: RawLocation): Promise<Route> {
  return (originalPush.call(this, location) as unknown as Promise<Route>).catch((err: Error) => {
    if (err.name !== 'NavigationDuplicated') throw err;
    return this.currentRoute;
  });
};

const routes: Array<RouteConfig> = [
  {
    path: '/non-trouve',
    name: 'notFound',
    component: PageNotFound,
    meta: {title: 'Page introuvable'},
  },
  {
    path: '/:slug',
    name: 'home',
    component: Home,
    meta: {title: 'Accueil'},
  },
  {
    path: '/:slug/MentionsLegales',
    name: 'legalNotice',
    component: MentionsLegales,
    meta: {title: 'Mentions Légales'},
  },
  {
    path: '/:slug/cgu',
    name: 'termsOfService',
    component: Cgu,
    meta: {title: 'CGU'},
  },
  {
    path: '/:slug/service/:service',
    name: 'onlineService',
    component: OnlineService,
    meta: {title: 'Service en ligne'},
  },
  ...menuRoutes,
  ...articleRoutes,
  ...bookingRoutes,
  ...feedbackRoutes,
  {
    path: '/*',
    redirect: '/non-trouve',
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to: Route, from: Route, next: NavigationGuardNext): void => {
  if (to.params.slug && !router.app.$store.getters['site/customerId']) {
    store.dispatch('site/getSite', to.params.slug);
  }
  next();
});

router.afterEach((to: Route): void => {
  if (to.params.slug === 'fr1533lectra' && window.umami) {
    window.umami.track();
  }
});
export default router;
